$(document).ready(function () {
//   if ($(".mobile-nav__link").hasClass("mobile-clickable-new")) {
  
//   }else{
    const subMenuBtn = document.querySelectorAll(
      "button.btn--link.parent-menu.js-toggle-submenu.mobile-nav__link"
    );
  
    // Submenu
    subMenuBtn &&
      subMenuBtn.forEach((btn) => {
        btn.addEventListener("click", (event) => {
           $('button.btn--link.parent-menu.js-toggle-submenu.mobile-nav__link').removeClass('is-active');
          if(!event.target.classList.contains("mobile-clickable-new")){
        
          if (event.target.classList.contains("is-menu-active")) {
            event.target.classList.remove("is-menu-active");
          } else {
            event.target.classList.add("is-menu-active");
          }
          }
        });
      });
  
  const subMenuBtn2 = document.querySelectorAll(
      ".mobile-first-menu-link "
    );
  
    // Submenu
    subMenuBtn2 &&
      subMenuBtn2.forEach((btn) => {
        btn.addEventListener("click", (event) => {
          event.target.classList.toggle("active-new");
          $(event.target).next('button.btn--link.parent-menu.js-toggle-submenu.mobile-nav__link').toggleClass('is-menu-active');
        $('button.btn--link.parent-menu.js-toggle-submenu.mobile-nav__link').removeClass('is-active');
        });
      });
  $('.mobile-nav__sublist-link').click(function(){
    $(this).toggleClass('is-active');
  });
  $('.mobile-subnav-icon').click(function(){
    $(this).toggleClass('active-new');
    $(this).next().toggleClass('is-active');
  });
     $('body').on('click','.swatch-element',function(){
  var prc = $(this).attr('data-price');

      var compr = $(this).attr('data-percent');
      var price1 = $(this).attr('data-cust');
    //  $('.tdf_price_sales span').html(compr);
   //   $('.tdf_price_original span').html(price1);
     $('.product-template__container .price-item').html(prc);
      $('#ShopNowContainer .price-item').html(prc);
   });
  });
  
    